import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveFileUploadFromContentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveFileUploadFromContentMutation = { __typename?: 'RootMutationType', removeFileUploadFromContent?: { __typename?: 'ContentResult', content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null, insertedAt?: any | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const RemoveFileUploadFromContentDocument = gql`
    mutation removeFileUploadFromContent($id: ID!) {
  removeFileUploadFromContent(id: $id) {
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      oembedResult
      providerName
      videoContain
      file {
        id
        name
        size
        pageCount
        mimeType
        fileUrl
        insertedAt
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type RemoveFileUploadFromContentMutationFn = Apollo.MutationFunction<RemoveFileUploadFromContentMutation, RemoveFileUploadFromContentMutationVariables>;

/**
 * __useRemoveFileUploadFromContentMutation__
 *
 * To run a mutation, you first call `useRemoveFileUploadFromContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileUploadFromContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFileUploadFromContentMutation, { data, loading, error }] = useRemoveFileUploadFromContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFileUploadFromContentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFileUploadFromContentMutation, RemoveFileUploadFromContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFileUploadFromContentMutation, RemoveFileUploadFromContentMutationVariables>(RemoveFileUploadFromContentDocument, options);
      }
export type RemoveFileUploadFromContentMutationHookResult = ReturnType<typeof useRemoveFileUploadFromContentMutation>;
export type RemoveFileUploadFromContentMutationResult = Apollo.MutationResult<RemoveFileUploadFromContentMutation>;
export type RemoveFileUploadFromContentMutationOptions = Apollo.BaseMutationOptions<RemoveFileUploadFromContentMutation, RemoveFileUploadFromContentMutationVariables>;